import paymentReducer from "./paymentSlice";

export default paymentReducer;
